import { isIntl } from '../react-process-env';
import { getLocaleStore } from './locale-store';

/**
 * 一些功能配置资源
 */
export function getConfigAssets() {
    return {
        /** 二维码功能 */
        qrCode: {
            /** 二维码内容 */
            text: isIntl ? 'https://www.x-design.com' : 'https://www.designkit.com',
            /** 微信公众号地址，解析公众号，得到二维码链接地址 */
            official: 'designmeitu',
        },
    };
}

/**
 * 使用素材中心地址
 * 会被写到配方里的资源
 */
export function getMaterialAssets() {
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en':
            return {
                /** 滤镜 */
                filter: {
                    /**
                     * 滤镜模块默认图
                     * 图层图片如果是透明图片
                     * 滤镜列表将使用该图做展示
                     */
                    defaultImg: 'https://x-design-release.stariidata.com/fe/dac43e9d71b0628d11b2588cc9b8ed18.jpg',
                },
                /** 团队  */
                team: {
                    /** 团队psd文件解析的默认封面 */
                    psdDefaultPreview:
                        'https://x-design-release.stariidata.com/fe/b64359f1db16c4d998a4e546a62e0834.png',
                },
                /** 画笔配置 */
                brush: {
                    /** 画笔多边形类型 */
                    polygon: {
                        triangle: 'https://x-design-release.stariidata.com/poster/cbbef87f0ddc2422c0551b87cc8ce5f0.svg',
                        heart: 'https://x-design-release.stariidata.com/fe/65a8924b49df99983.svg',
                        star: 'https://x-design-release.stariidata.com/poster/6bb20331d63d3ebefe43e0026297ba37.svg',
                        gon: 'https://x-design-release.stariidata.com/poster/33bc2cde51782c4d095d05275ac31c7e.svg',
                        label: 'https://x-design-release.stariidata.com/poster/d9b1569e9283d57c2f84efdb83cf944e.svg',
                        semicircle:
                            'https://x-design-release.stariidata.com/poster/3a748a9093ee11006d180a129cf3b4cc.svg',
                        bubble: 'https://x-design-release.stariidata.com/poster/cb6c8c2938770ef747905acc3cf10f5b.svg',
                        cloud: 'https://x-design-release.stariidata.com/poster/4fafc608f8132ebdc24a89b9f4c84868.svg',
                    },

                    /** AB实验画笔多边形类型 */
                    abPolygon: {
                        /** 三角形 */
                        triangle: 'https://x-design-release.stariidata.com/fe/triangle-3112007.svg',
                        /** 四边形 */
                        quadrilateral: 'https://x-design-release.stariidata.com/fe/quadrilateral.svg',
                        /** 五边形 */
                        pentagon: 'https://x-design-release.stariidata.com/fe/pentagon.svg',
                        /** 六边形 */
                        hexagon: 'https://x-design-release.stariidata.com/fe/hexagon.svg',
                        /** 八边形 */
                        octagon: 'https://x-design-release.stariidata.com/fe/octagon.svg',
                        /** 十二边形 */
                        dodecagon: 'https://x-design-release.stariidata.com/fe/dodecagon.svg',
                        /** 二十边形 */
                        icosagon: 'https://x-design-release.stariidata.com/fe/icosagon.svg',
                        /** 二十四边形 */
                        icosegment: 'https://x-design-release.stariidata.com/fe/icosegment.svg',
                        /** 三十二边形 */
                        trigonad: 'https://x-design-release.stariidata.com/fe/trigonad.svg',
                        /** 拱形 */
                        arch: 'https://x-design-release.stariidata.com/fe/arch.svg',
                        /** 矩形八边形 */
                        rectangleOctagon: 'https://x-design-release.stariidata.com/fe/rectangle-octagon.svg',
                        /** 下箭头 */
                        bottomArrow: 'https://x-design-release.stariidata.com/fe/bottom-arrow.svg',
                        /** 上箭头 */
                        topArrow: 'https://x-design-release.stariidata.com/fe/top-arrow.svg',
                        /** 左箭头 */
                        leftArrow: 'https://x-design-release.stariidata.com/fe/left-arrow.svg',
                        /** 右箭头 */
                        rightArrow: 'https://x-design-release.stariidata.com/fe/right-arrow.svg',
                        /** 禁止 */
                        ban: 'https://x-design-release.stariidata.com/fe/ban.svg',
                        /** 气泡1 */
                        bubble1: 'https://x-design-release.stariidata.com/fe/bubble-1.svg',
                        /** 气泡2 */
                        bubble2: 'https://x-design-release.stariidata.com/fe/bubble-2.svg',
                        /** 云 */
                        cloud: 'https://x-design-release.stariidata.com/fe/cloud.svg',
                        /** 十字 */
                        cross: 'https://x-design-release.stariidata.com/fe/cross.svg',
                        /** 菱形 */
                        diamond: 'https://x-design-release.stariidata.com/fe/diamond.svg',
                        /** 双箭头 */
                        doubleArrow: 'https://x-design-release.stariidata.com/fe/double-arrow.svg',
                        /** 旗帜1 */
                        flag1: 'https://x-design-release.stariidata.com/fe/flag-1.svg',
                        /** 旗帜2 */
                        flag2: 'https://x-design-release.stariidata.com/fe/flag-2.svg',
                        /** 旗帜3 */
                        flag3: 'https://x-design-release.stariidata.com/fe/flag-3.svg',
                        /** 心形 */
                        heart: 'https://x-design-release.stariidata.com/fe/heart.svg',
                        /** 加号 */
                        plus: 'https://x-design-release.stariidata.com/fe/plus.svg',
                        /** 半圆 */
                        semicircle: 'https://x-design-release.stariidata.com/fe/semicircle.svg',
                        /** 五角星星 */
                        star: 'https://x-design-release.stariidata.com/fe/star.svg',
                        /** 直角梯形 */
                        rightTrapezoid: 'https://x-design-release.stariidata.com/fe/trapezoid-right.svg',
                        /** 等腰梯形 */
                        isoscelesTrapezoid: 'https://x-design-release.stariidata.com/fe/isosceles-trapezoid.svg',
                    },

                    /** 画笔端点样式 */
                    point: {
                        StraightArrow: 'https://x-design-release.stariidata.com/fe/65aa4f3f0bb8f5498.svg',
                        CurvedArrow: 'https://x-design-release.stariidata.com/fe/65aa4e81f19565725.svg',
                        HalfArrow: 'https://x-design-release.stariidata.com/fe/65aa4eb4192712356.svg',
                        VerticalShape: 'https://x-design-release.stariidata.com/fe/65aa4f4f0e9c18749.svg',
                        SolidTriangle: 'https://x-design-release.stariidata.com/fe/65aa4f2ad49416325.svg',
                        SolidCircle: 'https://x-design-release.stariidata.com/fe/65aa4f19adb569945.svg',
                        HollowRect: 'https://x-design-release.stariidata.com/fe/65aa4f04290784540.svg',
                    },
                },
                /** 标注笔配置 */
                markup: {
                    /** 端点样式 */
                    point: {
                        /** 尖头三角形 */
                        SharpTriangle:
                            'https://x-design-release.stariidata.com/poster/ffa3a13fdbf97e1abc16d20f6a914800.svg',
                        /** 曲线箭头 */
                        CurvedArrow:
                            'https://x-design-release.stariidata.com/poster/035d3bc9817f8700b8ba5e475bb3c07d.svg',
                        /** 直线箭头 */
                        StraightArrow:
                            'https://x-design-release.stariidata.com/poster/5d8a49c7fce15ac07a1a87f4631c1bf1.svg',
                        /** 实心三角形 */
                        SolidTriangle:
                            'https://x-design-release.stariidata.com/poster/f61d10cdb9d0dac38593ef07d2e24c0b.svg',
                        /** 圆点 */
                        SolidCircle:
                            'https://x-design-release.stariidata.com/poster/221b5a923c7a530ee247bdde9277c222.svg',
                        /** 镂空矩形 */
                        HollowRect:
                            'https://x-design-release.stariidata.com/poster/fd194d53c9668c091d8b7609a4ec5101.svg',
                    },
                },
                /** 图片编辑器 */
                imageEditor: {
                    /** 样片地址 */
                    samplePiece: [
                        {
                            url: 'https://x-design-release.stariidata.com/user-poster-editor/bf721b70762296fb7465c80df8788c71.jpg',
                            name: 'SamplePiece 1',
                        },
                        {
                            url: 'https://x-design-release.stariidata.com/user-poster-editor/62d4fdf62c3021c2193eeac5c964b196.jpg',
                            name: 'SamplePiece 2',
                        },
                        {
                            url: 'https://x-design-release.stariidata.com/user-poster-editor/551dd2dfa342c926ecfa3329438651f2.jpg',
                            name: 'SamplePiece 3',
                        },
                        {
                            url: 'https://x-design-release.stariidata.com/user-poster-editor/77056a2d72fb359d61098eb6927a0782.jpg',
                            name: 'SamplePiece 4',
                        },
                        {
                            url: 'https://x-design-release.stariidata.com/user-poster-editor/a7a8c731c9b2b5282439017dad1e6902.jpg',
                            name: 'SamplePiece 5',
                        },
                    ],
                },
            };
        case 'cn':
        default:
            return {
                /** 滤镜 */
                filter: {
                    /**
                     * 滤镜模块默认图
                     * 图层图片如果是透明图片
                     * 滤镜列表将使用该图做展示
                     */
                    defaultImg: 'https://xiuxiu-pro.meitudata.com/poster/257c70ab95a1c96055761eddf0a45879.jpg',
                },
                /** 团队  */
                team: {
                    /** 团队psd文件解析的默认封面 */
                    psdDefaultPreview: 'https://xiuxiu-pro.meitudata.com/poster/272b86f6f861d83efff39bf9e7c4a9aa.png',
                },
                /** 画笔配置 */
                brush: {
                    /** 画笔多边形类型 */
                    polygon: {
                        triangle: 'https://xiuxiu-pro.meitudata.com/poster/8c5e78c280c3f7de70e014303514bc82.svg',
                        heart: 'https://material-center.meitudata.com/material/font/65a8924b49df99983.svg',
                        star: 'https://xiuxiu-pro.meitudata.com/poster/f545fe48b831c0abf67d5f5031e9a1ea.svg',
                        gon: 'https://xiuxiu-pro.meitudata.com/poster/f143547328f25b27c2318781dc4d3863.svg',
                        label: 'https://xiuxiu-pro.meitudata.com/poster/dae2eb7e7708e64789fe45a21ffa23c0.svg',
                        semicircle: 'https://xiuxiu-pro.meitudata.com/poster/4f10c2d22e93e9112dfbea691e277722.svg',
                        bubble: 'https://xiuxiu-pro.meitudata.com/poster/efcb0043f25120c52d773f37aa0087ca.svg',
                        cloud: 'https://xiuxiu-pro.meitudata.com/poster/ea09996fe763cbd580c5aa545d99cdb4.svg',
                    },
                    /** AB实验画笔多边形类型 */
                    abPolygon: {
                        /** 三角形 */
                        triangle: 'https://xiuxiu-pro.meitudata.com/poster/f42828ced6949214c8648f4c77bfad7f.svg',
                        /** 四边形 */
                        quadrilateral: 'https://xiuxiu-pro.meitudata.com/poster/abc7b451b840efae42ed8e4d80c66577.svg',
                        /** 五边形 */
                        pentagon: 'https://xiuxiu-pro.meitudata.com/poster/e842ba15ae830136a9ab87526be360ed.svg',
                        /** 六边形 */
                        hexagon: 'https://xiuxiu-pro.meitudata.com/poster/066a9e5e5c01be49d811bdfcfe835486.svg',
                        /** 八边形 */
                        octagon: 'https://xiuxiu-pro.meitudata.com/poster/f90e60a5bea1c63d18167b1dfddad80e.svg',
                        /** 十二边形 */
                        dodecagon: 'https://xiuxiu-pro.meitudata.com/poster/b90f6d73a0156eee900dfcadb5d42fb7.svg',
                        /** 二十边形 */
                        icosagon: 'https://xiuxiu-pro.meitudata.com/poster/c7a2d90e65437036af6e954ef4c1359b.svg',
                        /** 二十四边形 */
                        icosegment: 'https://xiuxiu-pro.meitudata.com/poster/2b6931be48026c9676c30c405a3b6021.svg',
                        /** 三十二边形 */
                        trigonad: 'https://xiuxiu-pro.meitudata.com/poster/1cd080a2b77689509bcf148653bac74b.svg',
                        /** 拱形 */
                        arch: 'https://xiuxiu-pro.meitudata.com/poster/51ccf6b7e1b4f5111f6c4da23ee38025.svg',
                        /** 矩形八边形 */
                        rectangleOctagon:
                            'https://xiuxiu-pro.meitudata.com/poster/49359ffc7ca26b94bc8762224a785ee5.svg',
                        /** 下箭头 */
                        bottomArrow: 'https://xiuxiu-pro.meitudata.com/poster/1140a08498fe7d477b25c09dc8f00945.svg',
                        /** 上箭头 */
                        topArrow: 'https://xiuxiu-pro.meitudata.com/poster/5ee23f9f84c63a5c8f8c3316394b0196.svg',
                        /** 左箭头 */
                        leftArrow: 'https://xiuxiu-pro.meitudata.com/poster/df31cc82034e42e8c3b5e41c98de77d8.svg',
                        /** 右箭头 */
                        rightArrow: 'https://xiuxiu-pro.meitudata.com/poster/2d8eacf7708dcb606f334d231599d672.svg',
                        /** 禁止 */
                        ban: 'https://xiuxiu-pro.meitudata.com/poster/d5f4c702b94f6d7d7d1a1b3c70f6a1e9.svg',
                        /** 气泡1 */
                        bubble1: 'https://xiuxiu-pro.meitudata.com/poster/01b940916a6445c871cb04d09bf686df.svg',
                        /** 气泡2 */
                        bubble2: 'https://xiuxiu-pro.meitudata.com/poster/ca35f7e95c3b51cb5a1d04eec3b43b01.svg',
                        /** 云 */
                        cloud: 'https://xiuxiu-pro.meitudata.com/poster/fec577d3ae9eca61f8789195d5d25f8d.svg',
                        /** 十字 */
                        cross: 'https://xiuxiu-pro.meitudata.com/poster/fc6458c89770590cfe89e7b20ad49fc3.svg',
                        /** 菱形 */
                        diamond: 'https://xiuxiu-pro.meitudata.com/poster/0229e099eb64293d0cb9826998ce4be9.svg',
                        /** 双箭头 */
                        doubleArrow: 'https://xiuxiu-pro.meitudata.com/poster/d3a0f62a04eba43923fa522e57c70110.svg',
                        /** 旗帜1 */
                        flag1: 'https://xiuxiu-pro.meitudata.com/poster/51fe8a02acdc39272ccb4067e2d83569.svg',
                        /** 旗帜2 */
                        flag2: 'https://xiuxiu-pro.meitudata.com/poster/31183c1e8657c4402b6bb6764f76ed64.svg',
                        /** 旗帜3 */
                        flag3: 'https://xiuxiu-pro.meitudata.com/poster/8affbb1a6ffff42957a73164ccbb3513.svg',
                        /** 心形 */
                        heart: 'https://xiuxiu-pro.meitudata.com/poster/47f2168fdc587234ae6f9ae18bf0f63e.svg',
                        /** 加号 */
                        plus: 'https://xiuxiu-pro.meitudata.com/poster/852070fd7712d364558c2a7e76820655.svg',
                        /** 半圆 */
                        semicircle: 'https://xiuxiu-pro.meitudata.com/poster/95a4f4d0a6889170ca7f2051f90b68fd.svg',
                        /** 五角星星 */
                        star: 'https://xiuxiu-pro.meitudata.com/poster/6c6836d0abdd962bb90d3a0ca6e46696.svg',
                        /** 直角梯形 */
                        rightTrapezoid: 'https://xiuxiu-pro.meitudata.com/poster/6df137aa67ddbb69701d309791ccaae7.svg',
                        /** 等腰梯形 */
                        isoscelesTrapezoid:
                            'https://xiuxiu-pro.meitudata.com/poster/08fa52274310cda6bf9c4b7bb72de253.svg',
                    },
                    /** 画笔端点样式 */
                    point: {
                        StraightArrow: 'https://material-center.meitudata.com/material/font/65aa4f3f0bb8f5498.svg',
                        CurvedArrow: 'https://material-center.meitudata.com/material/font/65aa4e81f19565725.svg',
                        HalfArrow: 'https://material-center.meitudata.com/material/font/65aa4eb4192712356.svg',
                        VerticalShape: 'https://material-center.meitudata.com/material/font/65aa4f4f0e9c18749.svg',
                        SolidTriangle: 'https://material-center.meitudata.com/material/font/65aa4f2ad49416325.svg',
                        SolidCircle: 'https://material-center.meitudata.com/material/font/65aa4f19adb569945.svg',
                        HollowRect: 'https://material-center.meitudata.com/material/font/65aa4f04290784540.svg',
                    },
                },
                /** 标注笔配置 */
                markup: {
                    /** 端点样式 */
                    point: {
                        /** 尖头三角形 */
                        SharpTriangle: 'https://material-center.meitudata.com/material/image/66f9054d4367e8666.svg',
                        /** 曲线箭头 */
                        CurvedArrow: 'https://material-center.meitudata.com/material/image/66f90510914906642.svg',
                        /** 直线箭头 */
                        StraightArrow: 'https://material-center.meitudata.com/material/image/66f905381b0c9179.svg',
                        /** 实心三角形 */
                        SolidTriangle: 'https://material-center.meitudata.com/material/image/66f90544439705128.svg',
                        /** 圆点 */
                        SolidCircle: 'https://material-center.meitudata.com/material/image/66ebe179a63a4774.svg',
                        /** 镂空矩形 */
                        HollowRect: 'https://material-center.meitudata.com/material/image/66f905569752f1994.svg',
                    },
                },
                /** 图片编辑器 */
                imageEditor: {
                    /** 样片地址 */
                    samplePiece: [
                        {
                            url: 'https://xiuxiupro-material-center.meitudata.com/poster/a5b124caae6c1f35be58ba7ba651725a.jpg',
                            name: '美图秀秀 样片1',
                        },
                        {
                            url: 'https://xiuxiupro-material-center.meitudata.com/poster/9db01920b813f18321274bc13da283db.jpg',
                            name: '美图秀秀 样片2',
                        },
                        {
                            url: 'https://xiuxiupro-material-center.meitudata.com/poster/325cb902e32aa5b426c765cc53ffbac8.jpeg',
                            name: '美图秀秀 样片3',
                        },
                    ],
                },
            };
    }
}

/**
 * 较大文件，不适合放在项目里的
 */
export function getBigAssets() {
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en':
            return {
                /** ppt 介绍视频 */
                ppt: {
                    webp: 'https://x-design-release.stariidata.com/fe/ai-ppt.webp',
                    video: 'https://x-design-release.stariidata.com/fe/061295b030a86dc2f55151276d707826.mp4',
                },
                /** 一键生成ai照片 介绍视频 */
                aiPhoto: {
                    light: 'https://x-design-release.stariidata.com/fe/intro_video.mp4',
                    dark: 'https://x-design-release.stariidata.com/fe/intro_video_black.mp4',
                },
                /** 一键生成ai背景 介绍视频 */
                aiBg: {
                    light: 'https://x-design-release.stariidata.com/fe/intro_video_bg2.mp4',
                    dark: 'https://x-design-release.stariidata.com/fe/intro_video_bg_black2.mp4',
                },
                /** 一键生成ai海报 介绍视频  */
                aiPoster: {
                    video: 'https://public.static.meitudata.com/xiuxiu-pc/user-poster-editor/ai-hb.mp4',
                    // safari:
                    //     'https://x-design-release.stariidata.com/fe/ai-hb-0517.mp4',
                    // other:
                    //     'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/ai-hb-0517-new.mp4',
                    webp: 'https://x-design-release.stariidata.com/fe/ai-hb-0517-new.webp',
                },
            };
        case 'cn':
        default:
            return {
                /** ppt 介绍视频 */
                ppt: {
                    webp: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/ai-ppt.webp',
                    video: 'https://xiuxiupro-material-center.meitudata.com/poster/061295b030a86dc2f55151276d707826.mp4',
                },
                /** 一键生成ai照片 介绍视频 */
                aiPhoto: {
                    light: 'https://xiuxiu-pro.meitudata.com/ai_material/static/intro_video.mp4',
                    dark: 'https://xiuxiu-pro.meitudata.com/ai_material/static/intro_video_black.mp4',
                },
                /** 一键生成ai背景 介绍视频 */
                aiBg: {
                    light: 'https://xiuxiu-pro.meitudata.com/ai_material/static/intro_video_bg2.mp4',
                    dark: 'https://xiuxiu-pro.meitudata.com/ai_material/static/intro_video_bg_black2.mp4',
                },
                /** 一键生成ai海报 介绍视频  */
                aiPoster: {
                    // safari:
                    //     'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/ai-hb-0517.mp4',
                    // other:
                    //     'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/ai-hb-0517-new.mp4',
                    // webp:
                    //     'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/ai-hb-0517-new.webp'
                    video: 'https://public.static.meitudata.com/xiuxiu-pc/user-poster-editor/ai-hb.mp4',
                    webp: 'https://x-design-release.stariidata.com/fe/ai-hb-0517-new.webp',
                },
            };
    }
}

/**
 * 一些外链资源
 */
export function getLinksAssets() {
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en':
            return {
                /** X-Design 用户协议 */
                terms: 'https://www.x-design.com/terms-of-service',
                /** 弹窗提示升级 */
                version: {
                    official: 'https://www.designkit.com/',
                    dmg: 'https://xiuxiu.dl.meitu.com/xiuxiumac_setup.dmg',
                    appStore:
                        'https://apps.apple.com/cn/app/%E7%BE%8E%E5%9B%BE%E7%A7%80%E7%A7%80-%E5%9B%BE%E7%89%87%E7%BC%96%E8%BE%91%E4%B8%8E%E5%8A%9E%E5%85%AC%E8%AE%BE%E8%AE%A1%E5%B7%A5%E5%85%B7/id1588231633?mt=12',
                    exe: 'https://xiuxiu.dl.meitu.com/xiuxiu64_pc.exe',
                },
                /** 视觉设计稿审核标准 */
                psdDoc: 'https://www.yuque.com/meitumcp/vvtts5/gfv8e5',
                /** 华为PC预装定制版内嵌下载 */
                huaweiDownload: 'https://pc.meitu.com/download?channel=zhyshop',
            };
        case 'cn':
        default:
            return {
                /** 美图秀秀WEB用户协议 */
                terms: 'https://www.designkit.com/agreement',
                /**隐私协议 */
                privacyAgreement: 'https://www.designkit.com/legal-agreement',
                /** 弹窗提示升级 */
                version: {
                    official: 'https://www.designkit.com/',
                    dmg: 'https://xiuxiu.dl.meitu.com/xiuxiumac_setup.dmg',
                    appStore:
                        'https://apps.apple.com/cn/app/%E7%BE%8E%E5%9B%BE%E7%A7%80%E7%A7%80-%E5%9B%BE%E7%89%87%E7%BC%96%E8%BE%91%E4%B8%8E%E5%8A%9E%E5%85%AC%E8%AE%BE%E8%AE%A1%E5%B7%A5%E5%85%B7/id1588231633?mt=12',
                    exe: 'https://xiuxiu.dl.meitu.com/xiuxiu64_pc.exe',
                },
                /** 视觉设计稿审核标准 */
                psdDoc: 'https://www.yuque.com/meitumcp/vvtts5/gfv8e5',
                /** 华为PC预装定制版内嵌下载 */
                huaweiDownload: 'https://pc.meitu.com/download?channel=zhyshop',
            };
    }
}

/**
 *
 */
export function getShortcutCollapseAssets() {
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en':
            return {
                /** 创建图层时初始的screenshotUrl属性 */
                initialLayerScreenshotUrl: {
                    deformedTextLayer:
                        'https://x-design-release.stariidata.com/poster/3a9d57eabc788acba84de7ee39ac4cdd.png',
                    brushLineLayer:
                        'https://x-design-release.stariidata.com/poster/355b28bfdef4cf18d8298f41d482d9f2.png',
                    brushPinkCircleLayer:
                        'https://x-design-release.stariidata.com/poster/721248871350e19099e780fe43f557b5.png',
                    brushBlueRectLayer:
                        'https://x-design-release.stariidata.com/poster/94ce0031d7c2a43dde2fad29a8da3616.png',
                    brushBlackSquareLayer:
                        'https://x-design-release.stariidata.com/poster/4b92a400b23cfb5f22ef4bb9580e8455.png',
                    brushArrowLineLayer:
                        'https://x-design-release.stariidata.com/poster/ffa3d46075d8c373e72aadb7563b0a99.png',
                    brushGradientRectLayer:
                        'https://x-design-release.stariidata.com/poster/91d6ced4a65f048d15cf3bb6dbb5cf09.png',
                },
            };
        case 'cn':
        default:
            return {
                /** 创建图层时初始的screenshotUrl属性 */
                initialLayerScreenshotUrl: {
                    deformedTextLayer: 'https://xiuxiu-pro.meitudata.com/poster/34bffb6c10c280684ff0906a4c231047.png',
                    brushLineLayer: 'https://xiuxiu-pro.meitudata.com/poster/69f84b31de08c36f3fe3fbec02db4588.png',
                    brushPinkCircleLayer:
                        'https://xiuxiu-pro.meitudata.com/poster/6e693d246912727d467f89d6bbf71320.png',
                    brushBlueRectLayer: 'https://xiuxiu-pro.meitudata.com/poster/699fc5b3822c02e5ff7ef82d22202122.png',
                    brushBlackSquareLayer:
                        'https://xiuxiu-pro.meitudata.com/poster/b3de935e06ab1017d79387f090a06e27.png',
                    brushArrowLineLayer: 'https://xiuxiu-pro.meitudata.com/poster/192f2ba15caa0c3ac994c8967eeb8489.png',
                    brushGradientRectLayer:
                        'https://xiuxiu-pro.meitudata.com/poster/412af2a96dc9b05ca6a9decf2806492d.png',
                },
            };
    }
}
